import { AmplitudeEvent } from './base-events';
import { FunnelEvent, RevenueEvent } from './funnel-event';
export class CategoryNavItemSelectEvent extends AmplitudeEvent {
  constructor(uiRegion, categoryId, subCategoryId, topicId) {
    super();
    this.uiRegion = uiRegion;
    this.categoryId = categoryId;
    this.subCategoryId = subCategoryId;
    this.topicId = topicId;
    this.eventName = 'category_nav_item_select';
    this.category = 'navigation';
  }
  toEventProperties() {
    return {
      category_id: this.categoryId,
      subcategory_id: this.subCategoryId,
      topic_id: this.topicId,
      ui_region: this.uiRegion
    };
  }
}
export class CheckoutCompletedEvent extends RevenueEvent {
  constructor(orderId, paymentMethod, revenueObjects, currency, couponCode, totalValue, totalDiscountValue, totalItems, checkoutType) {
    super(orderId, paymentMethod, revenueObjects, currency, couponCode, totalValue, totalDiscountValue, totalItems);
    this.checkoutType = checkoutType;
    this.eventName = 'checkout_completed';
    this.category = 'commerce';
  }
  toEventProperties() {
    return {
      ...super.toEventProperties(),
      checkout_type: this.checkoutType
    };
  }
}
export class AddToCartEvent extends FunnelEvent {
  constructor(productEngagement) {
    super();
    this.eventName = 'add_to_cart_event';
    this.category = 'commerce';
    this.productEngagement = productEngagement;
    this.shouldMergeEngagementToCart = true;
  }
  toEventProperties() {
    return {
      ...super.toEventProperties()
    };
  }
}
export class BannerClickEvent extends AmplitudeEvent {
  constructor(noticeId, noticeType, personalizedNoticeSetId, personalizedNoticeSetName, topMembershipTargetGroupId, slideNumber, url, uiRegion) {
    super();
    this.noticeId = noticeId;
    this.noticeType = noticeType;
    this.personalizedNoticeSetId = personalizedNoticeSetId;
    this.personalizedNoticeSetName = personalizedNoticeSetName;
    this.topMembershipTargetGroupId = topMembershipTargetGroupId;
    this.slideNumber = slideNumber;
    this.url = url;
    this.uiRegion = uiRegion;
    this.eventName = 'banner_click';
    this.category = 'engagement';
  }
  toEventProperties() {
    return {
      notice_id: this.noticeId,
      notice_type: this.noticeType,
      personalized_notice_set_id: this.personalizedNoticeSetId,
      personalized_notice_set_name: this.personalizedNoticeSetName,
      top_membership_target_group_id: this.topMembershipTargetGroupId,
      slide_number: this.slideNumber,
      url: this.url,
      ui_region: this.uiRegion
    };
  }
}
export class BannerImpressionEvent extends AmplitudeEvent {
  constructor(noticeId, noticeType, personalizedNoticeSetId, personalizedNoticeSetName, topMembershipTargetGroupId, slideNumber) {
    super();
    this.noticeId = noticeId;
    this.noticeType = noticeType;
    this.personalizedNoticeSetId = personalizedNoticeSetId;
    this.personalizedNoticeSetName = personalizedNoticeSetName;
    this.topMembershipTargetGroupId = topMembershipTargetGroupId;
    this.slideNumber = slideNumber;
    this.eventName = 'banner_impression';
    this.category = 'engagement';
  }
  toEventProperties() {
    return {
      notice_id: this.noticeId,
      notice_type: this.noticeType,
      personalized_notice_set_id: this.personalizedNoticeSetId,
      personalized_notice_set_name: this.personalizedNoticeSetName,
      top_membership_target_group_id: this.topMembershipTargetGroupId,
      slide_number: this.slideNumber
    };
  }
}
export class BrowseNavigationItemSelected extends AmplitudeEvent {
  constructor(id, type, uiRegion, style, relatedEntityId, relatedEntityType) {
    super();
    this.id = id;
    this.type = type;
    this.uiRegion = uiRegion;
    this.style = style;
    this.relatedEntityId = relatedEntityId;
    this.relatedEntityType = relatedEntityType;
    this.eventName = 'browse_navigation_item_selected';
    this.category = 'navigation';
  }
  toEventProperties() {
    return {
      id: this.id,
      type: this.type,
      ui_region: this.uiRegion,
      style: this.style,
      related_entity_id: this.relatedEntityId,
      related_entity_type: this.relatedEntityType
    };
  }
}
export class CannotFindOccupationSelected extends AmplitudeEvent {
  constructor(isOnboarding) {
    super();
    this.isOnboarding = isOnboarding;
    this.eventName = 'cannot_find_occupation_selected';
    this.category = 'engagement';
  }
  toEventProperties() {
    return {
      is_onboarding: this.isOnboarding
    };
  }
}
export class CartCheckoutClickEvent extends FunnelEvent {
  constructor(componentVersion) {
    super();
    this.componentVersion = componentVersion;
    this.eventName = 'cart_checkout_click';
    this.category = 'commerce';
  }
  toEventProperties() {
    return {
      ...super.toEventProperties(),
      component_version: this.componentVersion
    };
  }
}
export class CertificationVoucherOfferPresented extends AmplitudeEvent {
  constructor(name, poolId, examId, uiRegion, voucherId) {
    super();
    this.name = name;
    this.poolId = poolId;
    this.examId = examId;
    this.uiRegion = uiRegion;
    this.voucherId = voucherId;
    this.eventName = 'certification_voucher_offer_presented';
    this.category = 'engagement';
  }
  toEventProperties() {
    return {
      name: this.name,
      pool_id: this.poolId,
      exam_id: this.examId,
      ui_region: this.uiRegion,
      voucher_id: this.voucherId
    };
  }
}
export class CertificationVoucherOfferSelected extends AmplitudeEvent {
  constructor(name, poolId, examId, uiRegion, voucherId) {
    super();
    this.name = name;
    this.poolId = poolId;
    this.examId = examId;
    this.uiRegion = uiRegion;
    this.voucherId = voucherId;
    this.eventName = 'certification_voucher_offer_selected';
    this.category = 'engagement';
  }
  toEventProperties() {
    return {
      name: this.name,
      pool_id: this.poolId,
      exam_id: this.examId,
      ui_region: this.uiRegion,
      voucher_id: this.voucherId
    };
  }
}
export class CheckoutSubmitEvent extends FunnelEvent {
  constructor(orderId, chargeType, invalidFields) {
    super();
    this.orderId = orderId;
    this.chargeType = chargeType;
    this.invalidFields = invalidFields;
    this.eventName = 'checkout_submit';
    this.category = 'commerce';
  }
  toEventProperties() {
    return {
      ...super.toEventProperties(),
      order_id: this.orderId,
      charge_type: this.chargeType,
      invalid_fields: this.invalidFields
    };
  }
}
export class CheckoutSubmitFailed extends FunnelEvent {
  constructor(orderId, chargeType, errorMessage) {
    super();
    this.orderId = orderId;
    this.chargeType = chargeType;
    this.errorMessage = errorMessage;
    this.eventName = 'checkout_submit_failed';
    this.category = 'commerce';
  }
  toEventProperties() {
    return {
      ...super.toEventProperties(),
      order_id: this.orderId,
      charge_type: this.chargeType,
      error_message: this.errorMessage
    };
  }
}
export class CouponApplied extends FunnelEvent {
  constructor(couponCode, discountedPrice, discountAmount) {
    super();
    this.couponCode = couponCode;
    this.discountedPrice = discountedPrice;
    this.discountAmount = discountAmount;
    this.eventName = 'coupon_applied';
    this.category = 'commerce';
  }
  toEventProperties() {
    return {
      ...super.toEventProperties(),
      coupon_code: this.couponCode,
      discounted_price: this.discountedPrice,
      discount_amount: this.discountAmount
    };
  }
}
export class CourseCompleted extends AmplitudeEvent {
  constructor(courseId) {
    super();
    this.courseId = courseId;
    this.eventName = 'course_completed';
    this.category = 'engagement';
  }
  toEventProperties() {
    return {
      course_id: this.courseId
    };
  }
}
export class DiscoveryItemClickEvent extends FunnelEvent {
  constructor(queryText, resultRank, discountAmount) {
    super();
    this.queryText = queryText;
    this.resultRank = resultRank;
    this.discountAmount = discountAmount;
    this.eventName = 'discovery_item_click';
    this.category = 'behavior';
  }
  toEventProperties() {
    return {
      ...super.toEventProperties(),
      query_text: this.queryText,
      result_rank: this.resultRank,
      discount_amount: this.discountAmount
    };
  }
}
export class DiscoveryItemImpressionEvent extends FunnelEvent {
  constructor(type, backendSourceOptions, uiRegion, position) {
    super();
    this.type = type;
    this.backendSourceOptions = backendSourceOptions;
    this.uiRegion = uiRegion;
    this.position = position;
    this.eventName = 'discovery_item_impression';
    this.category = 'behavior';
  }
  toEventProperties() {
    return {
      ...super.toEventProperties(),
      type: this.type,
      backend_source_options: this.backendSourceOptions,
      ui_region: this.uiRegion,
      position: this.position
    };
  }
}
export class EnrollNowEvent extends FunnelEvent {
  constructor(buyableId, buyableType) {
    super();
    this.buyableId = buyableId;
    this.buyableType = buyableType;
    this.eventName = 'enroll_now';
    this.category = 'commerce';
    this.productEngagement = [{
      id: buyableId,
      type: buyableType
    }];
    this.shouldMergeEngagementToCart = true;
  }
  toEventProperties() {
    return {
      ...super.toEventProperties(),
      buyable_id: this.buyableId,
      buyable_type: this.buyableType
    };
  }
}
export class ExternalClickEvent extends AmplitudeEvent {
  constructor(trackingLabel) {
    super();
    this.trackingLabel = trackingLabel;
    this.eventName = 'external_click';
    this.category = 'engagement';
  }
  toEventProperties() {
    return {
      tracking_label: this.trackingLabel
    };
  }
}
export class ExternalLeadFormSubmitEvent extends AmplitudeEvent {
  constructor(formId, isSuccessful, failureReason) {
    super();
    this.formId = formId;
    this.isSuccessful = isSuccessful;
    this.failureReason = failureReason;
    this.eventName = 'external_lead_form_submit';
    this.category = 'engagement';
  }
  toEventProperties() {
    return {
      form_id: this.formId,
      is_successful: this.isSuccessful,
      failure_reason: this.failureReason
    };
  }
}
export class GiftBuyablesStartEvent extends FunnelEvent {
  constructor() {
    super();
    this.eventName = 'gift_buyables_start';
    this.category = 'commerce';
  }
  toEventProperties() {
    return {
      ...super.toEventProperties()
    };
  }
}
export class GoalCollectionCompletedEvent extends AmplitudeEvent {
  constructor(isOnboarding) {
    super();
    this.isOnboarding = isOnboarding;
    this.eventName = 'goal_collection_completed';
    this.category = 'engagement';
  }
  toEventProperties() {
    return {
      is_onboarding: this.isOnboarding
    };
  }
}
export class GoalCollectionExitedEvent extends AmplitudeEvent {
  constructor(isOnboarding, uiRegion) {
    super();
    this.isOnboarding = isOnboarding;
    this.uiRegion = uiRegion;
    this.eventName = 'goal_collection_exited';
    this.category = 'engagement';
  }
  toEventProperties() {
    return {
      is_onboarding: this.isOnboarding,
      ui_region: this.uiRegion
    };
  }
}
export class GoalCollectionStartedEvent extends AmplitudeEvent {
  constructor(isOnboarding, firstVisit) {
    super();
    this.isOnboarding = isOnboarding;
    this.firstVisit = firstVisit;
    this.eventName = 'goal_collection_started';
    this.category = 'engagement';
  }
  toEventProperties() {
    return {
      is_onboarding: this.isOnboarding,
      first_visit: this.firstVisit
    };
  }
}
export class GuestCheckoutPaymentStepPresented extends FunnelEvent {
  constructor(orderId, chargeType) {
    super();
    this.orderId = orderId;
    this.chargeType = chargeType;
    this.eventName = 'guest_checkout_payment_step_presented';
    this.category = 'commerce';
  }
  toEventProperties() {
    return {
      ...super.toEventProperties(),
      order_id: this.orderId,
      charge_type: this.chargeType
    };
  }
}
export class IsManagerRoleSaved extends AmplitudeEvent {
  constructor(isManager, isOnboarding) {
    super();
    this.isManager = isManager;
    this.isOnboarding = isOnboarding;
    this.eventName = 'is_manager_role_saved';
    this.category = 'engagement';
  }
  toEventProperties() {
    return {
      is_manager: this.isManager,
      is_onboarding: this.isOnboarding
    };
  }
}
export class LearningForOccupationGroupSaved extends AmplitudeEvent {
  constructor(occupationGroupId, isOnboarding) {
    super();
    this.occupationGroupId = occupationGroupId;
    this.isOnboarding = isOnboarding;
    this.eventName = 'learning_for_occupation_group_saved';
    this.category = 'engagement';
  }
  toEventProperties() {
    return {
      occupation_group_id: this.occupationGroupId,
      is_onboarding: this.isOnboarding
    };
  }
}
export class LearningForOccupationSaved extends AmplitudeEvent {
  constructor(occupationId, isCustom, isOnboarding) {
    super();
    this.occupationId = occupationId;
    this.isCustom = isCustom;
    this.isOnboarding = isOnboarding;
    this.eventName = 'learning_for_occupation_saved';
    this.category = 'engagement';
  }
  toEventProperties() {
    return {
      occupation_id: this.occupationId,
      is_custom: this.isCustom,
      is_onboarding: this.isOnboarding
    };
  }
}
export class LoginSelectEvent extends AmplitudeEvent {
  constructor(uiRegion) {
    super();
    this.uiRegion = uiRegion;
    this.eventName = 'login_select';
    this.category = 'engagement';
  }
  toEventProperties() {
    return {
      ui_region: this.uiRegion
    };
  }
}
export class PasswordlessCheckoutAuthOptionSelected extends AmplitudeEvent {
  constructor(option) {
    super();
    this.option = option;
    this.eventName = 'passwordless_checkout_auth_option_selected';
    this.category = 'engagement';
  }
  toEventProperties() {
    return {
      option: this.option
    };
  }
}
export class PersonalPlanBannerClickEvent extends AmplitudeEvent {
  constructor() {
    super();
    this.eventName = 'personal_plan_banner_click';
    this.category = 'engagement';
  }
  toEventProperties() {
    return {};
  }
}
export class PersonalPlanBenefitsDialogPresentedEvent extends AmplitudeEvent {
  constructor(userCountry, hasFreeTrial, hasRetentionPromotion, renewalInterval) {
    super();
    this.userCountry = userCountry;
    this.hasFreeTrial = hasFreeTrial;
    this.hasRetentionPromotion = hasRetentionPromotion;
    this.renewalInterval = renewalInterval;
    this.eventName = 'personal_plan_benefits_dialog_presented';
    this.category = 'engagement';
  }
  toEventProperties() {
    return {
      user_country: this.userCountry,
      has_free_trial: this.hasFreeTrial,
      has_retention_promotion: this.hasRetentionPromotion,
      renewal_interval: this.renewalInterval
    };
  }
}
export class PersonalPlanCancelSubmittedEvent extends AmplitudeEvent {
  constructor(userCountry, hasFreeTrial, hasRetentionPromotion, renewalInterval) {
    super();
    this.userCountry = userCountry;
    this.hasFreeTrial = hasFreeTrial;
    this.hasRetentionPromotion = hasRetentionPromotion;
    this.renewalInterval = renewalInterval;
    this.eventName = 'personal_plan_cancel_submitted';
    this.category = 'engagement';
  }
  toEventProperties() {
    return {
      user_country: this.userCountry,
      has_free_trial: this.hasFreeTrial,
      has_retention_promotion: this.hasRetentionPromotion,
      renewal_interval: this.renewalInterval
    };
  }
}
export class PreviewVideoPlayEvent extends AmplitudeEvent {
  constructor(productId, previewId, nonInteraction, uiRegion, offset = 0) {
    super();
    this.productId = productId;
    this.previewId = previewId;
    this.nonInteraction = nonInteraction;
    this.uiRegion = uiRegion;
    this.offset = offset;
    this.eventName = 'preview_video_play';
    this.category = 'engagement';
  }
  toEventProperties() {
    return {
      product_id: this.productId,
      preview_id: this.previewId,
      offset: this.offset,
      non_interaction: this.nonInteraction,
      ui_region: this.uiRegion
    };
  }
}
export class PurchasedCertificationVoucherPresented extends AmplitudeEvent {
  constructor(name, poolId, examId, uiRegion, voucherId) {
    super();
    this.name = name;
    this.poolId = poolId;
    this.examId = examId;
    this.uiRegion = uiRegion;
    this.voucherId = voucherId;
    this.eventName = 'purchased_certification_voucher_presented';
    this.category = 'engagement';
  }
  toEventProperties() {
    return {
      name: this.name,
      pool_id: this.poolId,
      exam_id: this.examId,
      ui_region: this.uiRegion,
      voucher_id: this.voucherId
    };
  }
}
export class SignupSubmitEvent extends AmplitudeEvent {
  constructor(signupType, uiRegion, sendMeOffersChecked, redirect) {
    super();
    this.signupType = signupType;
    this.uiRegion = uiRegion;
    this.sendMeOffersChecked = sendMeOffersChecked;
    this.redirect = redirect;
    this.eventName = 'signup_submit';
    this.category = 'engagement';
  }
  toEventProperties() {
    return {
      signup_type: this.signupType,
      ui_region: this.uiRegion,
      send_me_offers_checked: this.sendMeOffersChecked,
      redirect: this.redirect
    };
  }
}
export class SkillInterestsSavedEvent extends AmplitudeEvent {
  constructor(skillTopicIds, isOnboarding) {
    super();
    this.skillTopicIds = skillTopicIds;
    this.isOnboarding = isOnboarding;
    this.eventName = 'skill_interests_saved';
    this.category = 'engagement';
  }
  toEventProperties() {
    return {
      skill_topic_ids: this.skillTopicIds,
      is_onboarding: this.isOnboarding
    };
  }
}
export class SmartbarHideEvent extends AmplitudeEvent {
  constructor(noticeId, noticeType, personalizedNoticeSetId, personalizedNoticeSetName, topMembershipTargetGroupId) {
    super();
    this.noticeId = noticeId;
    this.noticeType = noticeType;
    this.personalizedNoticeSetId = personalizedNoticeSetId;
    this.personalizedNoticeSetName = personalizedNoticeSetName;
    this.topMembershipTargetGroupId = topMembershipTargetGroupId;
    this.eventName = 'smartbar_hide';
    this.category = 'engagement';
  }
  toEventProperties() {
    return {
      notice_id: this.noticeId,
      notice_type: this.noticeType,
      personalized_notice_set_id: this.personalizedNoticeSetId,
      personalized_notice_set_name: this.personalizedNoticeSetName,
      top_membership_target_group_id: this.topMembershipTargetGroupId
    };
  }
}
export class SubscriptionCTAClickEvent extends AmplitudeEvent {
  constructor(planPriceId, planType, ctaType, uiRegion, courseId, courseTrackingId, planPriceIds) {
    super();
    this.planPriceId = planPriceId;
    this.planType = planType;
    this.ctaType = ctaType;
    this.uiRegion = uiRegion;
    this.courseId = courseId;
    this.courseTrackingId = courseTrackingId;
    this.planPriceIds = planPriceIds;
    this.eventName = 'subscription_cta_click';
    this.category = 'commerce';
  }
  toEventProperties() {
    return {
      plan_price_id: this.planPriceId,
      plan_type: this.planType,
      cta_type: this.ctaType,
      ui_region: this.uiRegion,
      course_id: this.courseId,
      course_tracking_id: this.courseTrackingId,
      plan_price_ids: this.planPriceIds
    };
  }
}
export class SubscriptionOfferImpressionEvent extends AmplitudeEvent {
  constructor(planPriceId, uiRegion, courseId, courseTrackingId, hasTrial, trialDays, badges, planPriceIds, url) {
    super();
    this.planPriceId = planPriceId;
    this.uiRegion = uiRegion;
    this.courseId = courseId;
    this.courseTrackingId = courseTrackingId;
    this.hasTrial = hasTrial;
    this.trialDays = trialDays;
    this.badges = badges;
    this.planPriceIds = planPriceIds;
    this.url = url;
    this.eventName = 'subscription_offer_impression';
    this.category = 'commerce';
  }
  toEventProperties() {
    return {
      plan_price_id: this.planPriceId,
      ui_region: this.uiRegion,
      course_id: this.courseId,
      course_tracking_id: this.courseTrackingId,
      has_trial: this.hasTrial,
      trial_days: this.trialDays,
      badges: this.badges,
      plan_price_ids: this.planPriceIds,
      url: this.url
    };
  }
}
export class SubscriptionOfferPresented extends AmplitudeEvent {
  constructor(price, listPrice, currency, renewalIntervalType, renewalIntervalCount, hasTrial, productType, countryCode, courseId, courseTrackingId, badges, uiRegion, trialDays) {
    super();
    this.price = price;
    this.listPrice = listPrice;
    this.currency = currency;
    this.renewalIntervalType = renewalIntervalType;
    this.renewalIntervalCount = renewalIntervalCount;
    this.hasTrial = hasTrial;
    this.productType = productType;
    this.countryCode = countryCode;
    this.courseId = courseId;
    this.courseTrackingId = courseTrackingId;
    this.badges = badges;
    this.uiRegion = uiRegion;
    this.trialDays = trialDays;
    this.eventName = 'subscription_offer_presented';
    this.category = 'commerce';
  }
  toEventProperties() {
    return {
      price: this.price,
      list_price: this.listPrice,
      currency: this.currency,
      renewal_interval_type: this.renewalIntervalType,
      renewal_interval_count: this.renewalIntervalCount,
      has_trial: this.hasTrial,
      product_type: this.productType,
      country_code: this.countryCode,
      course_id: this.courseId,
      course_tracking_id: this.courseTrackingId,
      badges: this.badges,
      ui_region: this.uiRegion,
      trial_days: this.trialDays
    };
  }
}
export class WishlistEvent extends FunnelEvent {
  constructor() {
    super();
    this.eventName = 'wishlist_event';
    this.category = 'commerce';
  }
  toEventProperties() {
    return {
      ...super.toEventProperties()
    };
  }
}
export class SubscriptionPlanCheckoutCompleted extends RevenueEvent {
  constructor(orderId, paymentMethod, revenueObjects, currency, couponCode, totalValue, totalDiscountValue, totalItems, productType, userCountry, hasFreeTrial, hasRetentionPromotion, renewalInterval) {
    super(orderId, paymentMethod, revenueObjects, currency, couponCode, totalValue, totalDiscountValue, totalItems);
    this.productType = productType;
    this.userCountry = userCountry;
    this.hasFreeTrial = hasFreeTrial;
    this.hasRetentionPromotion = hasRetentionPromotion;
    this.renewalInterval = renewalInterval;
    this.eventName = 'subscription_plan_checkout_completed';
    this.category = 'commerce';
  }
  toEventProperties() {
    return {
      ...super.toEventProperties(),
      product_type: this.productType,
      user_country: this.userCountry,
      has_free_trial: this.hasFreeTrial,
      has_retention_promotion: this.hasRetentionPromotion,
      renewal_interval: this.renewalInterval
    };
  }
}
export class BuyNowEvent extends FunnelEvent {
  constructor(buyableId, buyableType) {
    super();
    this.buyableId = buyableId;
    this.buyableType = buyableType;
    this.eventName = 'buy_now_clicked';
    this.category = 'commerce';
    this.productEngagement = [{
      id: buyableId,
      type: buyableType
    }];
    this.shouldMergeEngagementToCart = true;
  }
  toEventProperties() {
    return {
      ...super.toEventProperties(),
      buyable_id: this.buyableId,
      buyable_type: this.buyableType
    };
  }
}
//# sourceMappingURL=events.js.map